// extracted by mini-css-extract-plugin
export default {"wrapper":"loading__wrapper--tzMT","logo":"loading__logo--7rrL","fade":"loading__fade--gHdc","text":"loading__text--4yMH"};